export interface ApiAthleteTag {
  uuid: string;
  name: string;
  color: string;
}

export type UpdateTagRequestModel = Omit<ApiAthleteTag, 'uuid' | 'team'>;

export interface AthleteTagRequestModel {
  tags: string[];
}

export class AthleteTagBase {
  name: string;
  color: keyof typeof colorMap;

  constructor(data: {
    name: string;
    color: string;
  }) {
    this.name = data.name;

    if (tagColors.includes(data.color)) {
      this.color = data.color as keyof typeof colorMap;
    } else {
      this.color = '#B8B9B9' as keyof typeof colorMap;
    }
  }
}

export class AthleteTag extends AthleteTagBase {
  uuid: string;

  constructor(data: ApiAthleteTag) {
    super(data);
    this.uuid = data.uuid;
  }

  static clone(instance: AthleteTag): AthleteTag {
    const cloned = Object.create(AthleteTag.prototype) as AthleteTag;
    cloned.uuid = instance.uuid;
    cloned.name = instance.name;
    cloned.color = instance.color;
    return cloned;
  }
}


export const colorMap = {
  '#B8B9B9': {
    border: 'rgb(var(--v-theme-neutral-200))',
    background: 'rgb(var(--v-theme-neutral-50))',
  },
  '#EAA934': {
    border: 'rgb(var(--v-theme-products-finance-secondary))',
    background: 'rgb(var(--v-theme-products-finance-tertiary))',
  },
  '#8362CB': {
    border: 'rgb(var(--v-theme-products-development-secondary))',
    background: 'rgb(var(--v-theme-products-development-tertiary))',
  },
  '#1A6AFF': {
    border: 'rgb(var(--v-theme-products-operations-secondary))',
    background: 'rgb(var(--v-theme-products-operations-tertiary))',
  },
  '#2CC3F2': {
    border: 'rgb(var(--v-theme-products-branding-secondary))',
    background: 'rgb(var(--v-theme-products-branding-tertiary))',
  },
  '#0A8560': {
    border: 'rgb(var(--v-theme-products-performance-secondary))',
    background: 'rgb(var(--v-theme-products-performance-tertiary))',
  },
  '#A0D346': {
    border: 'rgb(var(--v-theme-products-recruiting-secondary))',
    background: 'rgb(var(--v-theme-products-recruiting-tertiary))',
  },
  '#D83D32': {
    border: 'rgb(var(--v-theme-feedback-error-200))',
    background: 'rgb(var(--v-theme-feedback-error-25))',
  },
  '#EF6820': {
    border: 'rgb(var(--v-theme-accent-orange-200))',
    background: 'rgb(var(--v-theme-accent-orange-25))',
  },
  '#FAC515': {
    border: 'rgb(var(--v-theme-accent-yellow-200))',
    background: 'rgb(var(--v-theme-accent-yellow-25))',
  },
  '#EE46BC': {
    border: 'rgb(var(--v-theme-accent-pink-200))',
    background: 'rgb(var(--v-theme-accent-pink-25))',
  },
  '#841651': {
    border: 'rgb(var(--v-theme-accent-pink-700))',
    background: 'rgb(var(--v-theme-accent-pink-200))',
  },
  '#FFFFFF': {
    border: 'rgb(var(--v-theme-neutral-200))',
    background: 'rgb(var(--v-theme-white))',
  },
};

export const tagColors = Object.keys(colorMap);

export type ColorMap = Record<keyof typeof colorMap, {
  border: string;
  background: string;
}>;
